// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"65":"f4cc4a8f","1599":"bfa6f3fd","2467":"f24400ee","5343":"22889318","8417":"30416118"}[chunkId] + ".min.css";
};